export const environment = {
    production: false,
    apiUrl: 'https://dev-api.thecheerforge.com/',
    apiUrl2: 'https://dev-api.thecheerforge.com/',
    STRIPE_PUBLIC_KEY: 'pk_test_WlILdWEim7lSwtIHnhhAff9j00JCmyatfm'
  };